import { render, staticRenderFns } from "./compagnyReturn.vue?vue&type=template&id=e6171b04"
import script from "./compagnyReturn.vue?vue&type=script&lang=js"
export * from "./compagnyReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports